import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { useInviteUserMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteUser',
  props: {
  ventureId: {
    type: String,
    required: true,
  },
  ventureName: {
    type: String,
    default: '',
  },
},
  emits: ["done"],
  setup(__props, { emit }: { emit: ({
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const dialogOpen = ref(false)
const email = ref('')
const inviteSent = ref(false)
const errorMessage = ref('')

const {
  mutate: inviteUser,
  loading,
  onError,
} = useInviteUserMutation()

onError((err) => {
  errorMessage.value = err.message ?? String(err)
})

async function sendInvite() {
  if (!email.value.trim()) return
  errorMessage.value = ''
  try {
    const response = await inviteUser({
      ventureId: props.ventureId,
      email: email.value.trim(),
    })
    const result = response?.data?.inviteUser
    if (!result?.success) {
      errorMessage.value = result?.message || ''
      inviteSent.value = false
      return
    }
    inviteSent.value = true
    emit('done')
  } catch {
    // onError handles message
  }
}

function close() {
  dialogOpen.value = false
  resetState()
}

function resetState() {
  email.value = ''
  inviteSent.value = false
  errorMessage.value = ''
}

watch(dialogOpen, (open) => {
  if (!open) resetState()
})

return { __sfc: true,props, emit, dialogOpen, email, inviteSent, errorMessage, inviteUser, loading, onError, sendInvite, close, resetState }
}

})